var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',[_vm._v(" "+_vm._s(_vm.label)+" "),_c('v-text-field',_vm._g(_vm._b({attrs:{"background-color":"white","outlined":"","validate-on-blur":_vm.validateOnBlur,"value":_vm.value},on:{"input":(value) => _vm.$emit('input', value)}},'v-text-field',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }